import React from 'react';
import AppBar from '../../../commons/AppBar'
import ButtonsModules from '../../../commons/ButtonsModules';
import SiteMap from '../../../commons/SiteMap';
import SpecificComponent from '../../../commons/SpecificComponent';
import { Grid } from '@material-ui/core';
import { TopButtons } from '../../../commons/TopButtons';
import FromServer from '../FromServer';
import BilantChartData from '../Components/BilantChartData';
import PreviziuniChartData from '../Components/PreviziuniChartData';
import ClientiNoiLunar from '../ClientiNoiLunar';


export default class ClientiNoiCastigatiLunar extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            bilantData: [],
            prognoza: [],
            topButtons: [{ id: 'clientilunar', label: 'Clienti noi castigari lunar', color: '#900DCB' },
            { id: 'trendpastrareclienti', label: 'Trendul de pastrare clienti, trimestru', color: '#C8C779' },
            { id: 'segmentareclienti', label: 'Segmentare clienti in functie de stare', color: '#59D862' },

            ],

            mapButtons: [{ id: 'financiarcontabil', label: 'Inapoi Financiar', color: '#900DCB' },
            { id: 'avc', label: 'Analiza de vanzari si client (AVC)', color: '#900DCB' },
            { id: 'analizaclientilornoi', label: 'Analiza clientilor noi, loaiali si pierduti', color: '#900DCB' }
            ]
        }
    }

    componentDidMount() {


    }

    goTo = (id) => {
        this.props.history.push(`/${id}`)
    }


    render() {
        return (
            <div>
                <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.financiar} />

                <ButtonsModules history={this.props.history}
                    scop={'Financiar'} />

                <div style={{ textAlign: 'left' }}>
                    {this.state.mapButtons.map((b, idx) => {
                        return (
                            <SiteMap
                                key={idx}
                                b={b}
                                buttonSelected={this.goTo} />

                        )
                    })}
                </div>
                <h1 className='pm-title'>Clienti noi castigati lunar</h1>
              

                    <ClientiNoiLunar an={this.state.an} />
            </div>
        );
    }
}